import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/** Password input with a reveal toggle. Accepts any native input props. */
export const PasswordField = ({ testId, className = "input-flat", ...props }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        {...props}
        type={visible ? "text" : "password"}
        className={className}
        style={{ paddingRight: "2.75rem", ...(props.style || {}) }}
        data-testid={testId}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        className="absolute right-0 top-0 flex h-full w-11 items-center justify-center transition-opacity hover:opacity-100"
        style={{ color: "var(--muted)", opacity: 0.75 }}
        data-testid={testId ? `${testId}-toggle` : "password-reveal-toggle"}
      >
        {visible ? <EyeOff size={17} /> : <Eye size={17} />}
      </button>
    </div>
  );
};

export default PasswordField;
